module.exports = "/_next/static/images/9d335477423534b350fd9fb122a60080-iPhone12pro_1.png.webp";